module.exports = __webpack_public_path__ + "img/v2_woman.395ee0eb.svg";